import type { ConversationThread } from "@redotech/effect-api-shared/models/shopper-ai/conversation/thread";
import { memo } from "react";
import { ChatThreadView } from "./chat-thread-view";

interface InstagramThreadViewProps {
  thread: ConversationThread;
}

export const InstagramThreadView = memo(function InstagramThreadView({
  thread,
}: InstagramThreadViewProps) {
  return <ChatThreadView channel="instagram" thread={thread} />;
});
